import { render, staticRenderFns } from "./PaperResultSave.vue?vue&type=template&id=7db06674"
import script from "./PaperResultSave.vue?vue&type=script&lang=js"
export * from "./PaperResultSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports